export default __webpack_public_path__ + "582cf8737d9d47b4068b789c4bde7f78.svg";